import baseRates from "./baseRates.json";

/* Sample DELL story for the /kfm mockup variants (illustrative); baseRates.json = REAL
   historical base rates computed by studies/kfm_mockup_baserates.py. */
export { baseRates };

export const STOCK = {
  sym: "DELL", name: "Dell Technologies", sector: "Technology", mcap: "$64B", coverage: "A",
  score: 78, verdict: "ATTRACTIVE ENTRY", price: 109.4, basis: 101.8, rawPrem: 7.5, bpRel: 4.1, bpPct: 72,
  band: "S8", nBuyers: 9, day: 47, sinceDisclosure: 3.0, revealDate: "Aug 12",
  trend21: 2.3, regime: "Compounding Drift", tape: "Neutral", nextPrint: "Nov 2", daysToPrint: 12,
};

export const PRICES = [
  98.6, 97.2, 99.4, 100.8, 99.9, 101.5, 102.4, 101.1, 103.0, 102.2, 104.6, 106.2, 105.1,
  107.8, 106.9, 108.8, 107.4, 109.9, 108.6, 110.4, 109.4,
].map((px, i) => ({ i, px }));
export const BUILD = { x1: 1, x2: 9 };
export const REVEAL_IDX = 11;

export const LEDGER = [
  { fund: "Coatue Management", type: "HF", skill: 92, hit: 64, q: { "26Q2": "N" }, cost: 101.8, pos: "$412M", book: "2.1%" },
  { fund: "Darsana Capital", type: "HF", skill: 88, hit: 61, q: { "26Q2": "N" }, cost: 101.8, pos: "$188M", book: "3.4%" },
  { fund: "Tiger Global", type: "HF", skill: 74, hit: 58, q: { "26Q2": "N" }, cost: 101.8, pos: "$240M", book: "1.2%" },
  { fund: "Viking Global", type: "HF", skill: 71, hit: 57, q: { "26Q1": "N", "26Q2": "A" }, cost: 99.6, pos: "$95M", book: "0.4%" },
  { fund: "Holocene Advisors", type: "HF", skill: 66, hit: 55, q: { "26Q1": "N" }, cost: 96.4, pos: "$61M", book: "0.9%" },
  { fund: "Atreides Management", type: "HF", skill: 61, hit: 54, q: { "26Q1": "N" }, cost: 96.4, pos: "$44M", book: "1.6%" },
  { fund: "Alkeon Capital", type: "HF", skill: 58, hit: 53, q: { "26Q2": "N" }, cost: 101.8, pos: "$70M", book: "0.8%" },
  { fund: "Light Street Capital", type: "HF", skill: 52, hit: 51, q: { "26Q2": "N" }, cost: 101.8, pos: "$22M", book: "1.9%" },
  { fund: "Jericho Capital", type: "HF", skill: 47, hit: 50, q: { "26Q2": "N" }, cost: 101.8, pos: "$18M", book: "1.1%" },
  { fund: "Whale Rock Capital", type: "HF", skill: 81, hit: 59, q: { "25Q3": "N", "26Q1": "H" }, cost: 118.2, pos: "$130M", book: "2.6%", older: true },
  { fund: "T. Rowe Price", type: "LO", skill: 63, hit: 54, q: { "25Q4": "A", "26Q2": "H" }, cost: 114.7, pos: "$1.2B", book: "0.3%", older: true },
  { fund: "Two Sigma", type: "Quant", skill: 41, hit: 49, q: { "26Q2": "T" }, cost: 104.9, pos: "$31M", book: "0.1%", older: true },
  { fund: "Marshall Wace", type: "HF", skill: 38, hit: 48, q: { "26Q1": "X" }, cost: null, pos: "—", book: "—", older: true },
];
export const QUARTERS = ["25Q3", "25Q4", "26Q1", "26Q2"];

export const PEERS = [
  { sym: "DELL", bp: 4.1, v3: 5.0, holders: 312, band: "S8", me: true },
  { sym: "MRVL", bp: 9.8, v3: 11.4, holders: 401, band: "S10" },
  { sym: "CIEN", bp: 14.2, v3: 9.6, holders: 288, band: "S10" },
  { sym: "INTC", bp: 12.5, v3: 8.8, holders: 590, band: "S10" },
  { sym: "LITE", bp: 21.5, v3: 7.2, holders: 205, band: "S9" },
  { sym: "MU", bp: 6.3, v3: 6.1, holders: 520, band: "S9" },
  { sym: "ANET", bp: 2.2, v3: 3.1, holders: 455, band: "S7" },
  { sym: "NTAP", bp: -1.2, v3: 2.4, holders: 310, band: "S6" },
  { sym: "WDC", bp: 5.0, v3: 1.9, holders: 330, band: "S5" },
  { sym: "HPQ", bp: -3.5, v3: 0.8, holders: 380, band: "S4" },
  { sym: "STX", bp: 1.0, v3: -0.5, holders: 300, band: "S3" },
  { sym: "CSCO", bp: -0.8, v3: 0.2, holders: 610, band: "S3" },
  { sym: "SMCI", bp: -11.8, v3: 4.5, holders: 260, band: "S8", lottery: true },
];

export const TRIPWIRES = [
  { id: "basis", name: "Basis floor (dip-lottery zone)", rule: "Sector-adj basis premium falls below the season's 30th pct (≈ −6.0%)",
    now: "+4.1%", trigger: "−6.0%", progress: 0.29, status: "SAFE",
    means: "Cohort fails the V3 basis-quality gate; high-mean / weak-median lottery profile." },
  { id: "exit", name: "Smart exit pressure", rule: "≥ 2 holders with skill ≥ 80th pct exit or trim within 2 quarters",
    now: "0 of 2", trigger: "2", progress: 0.0, status: "SAFE",
    means: "Validated secondary negative (NW-t 2.57); score drops and verdict reviewed." },
  { id: "trend", name: "Trend fading", rule: "21-session sector-relative trend turns ≤ 0",
    now: "+2.3%", trigger: "0.0%", progress: 0.55, status: "WATCH",
    means: "The only validated mid-holding layer in V3; one of the 5 RED flags." },
  { id: "red", name: "RED earnings setup", rule: "≥ 3 of 5 flags into the print",
    now: "1 of 5", trigger: "3", progress: 0.33, status: "SAFE",
    means: "Earnings-day drift −43bp vs +73bp for clean setups (OOS); not a miss predictor." },
  { id: "regime", name: "Regime downgrade", rule: "Nowcast archetype moves to Distribution Phase / Overcrowded Peak",
    now: "Compounding Drift (p 0.61)", trigger: "weak archetype", progress: 0.12, status: "SAFE",
    means: "Confidence lens — lowers conviction, does not flip direction." },
  { id: "tape", name: "Options tape turns Hot", rule: "Options microstate classified Hot",
    now: "Neutral", trigger: "Hot", progress: 0.4, status: "CONTEXT",
    means: "Champion machine requires non-Hot tape; descriptive for Entry Anchoring." },
];

export const SCREENER = [
  { sym: "DELL", verdict: "Attractive entry", vcol: "text-emerald-400", score: 78, vs: "+4.1%", nm: "9", lv: "0", earn: "12d · GREEN", sector: "Technology" },
  { sym: "LIN", verdict: "Champion hold", vcol: "text-violet-300", score: 74, vs: "+1.1%", nm: "5", lv: "0", earn: "28d", sector: "Materials" },
  { sym: "MRVL", verdict: "Attractive entry", vcol: "text-emerald-400", score: 71, vs: "+9.8%", nm: "12", lv: "1", earn: "19d · GREEN", sector: "Technology" },
  { sym: "ELV", verdict: "Champion hold", vcol: "text-violet-300", score: 66, vs: "+3.2%", nm: "3", lv: "0", earn: "33d", sector: "Healthcare" },
  { sym: "UAL", verdict: "Neutral", vcol: "text-zinc-300", score: 63, vs: "+4.5%", nm: "4", lv: "1", earn: "41d", sector: "Industrials" },
  { sym: "KO", verdict: "Neutral", vcol: "text-zinc-300", score: 51, vs: "+0.3%", nm: "1", lv: "0", earn: "22d", sector: "Staples" },
  { sym: "GRMN", verdict: "Caution — distribution", vcol: "text-amber-400", score: 31, vs: "−6.1%", nm: "0", lv: "4", earn: "9d · RED", sector: "Technology" },
  { sym: "ZSPC", verdict: "Avoid — red flags", vcol: "text-red-400", score: 24, vs: "−9.8%", nm: "0", lv: "3", earn: "5d · RED", sector: "Technology" },
];

export const pathAt = (day) => {
  const p = baseRates.path_s8;
  const j = p.findIndex((r) => r.day >= day);
  if (j <= 0) return p[0];
  const a = p[j - 1], b = p[j], w = (day - a.day) / (b.day - a.day);
  const mix = (k) => a[k] + (b[k] - a[k]) * w;
  return { day, p25: mix("p25"), p50: mix("p50"), p75: mix("p75") };
};

export const DELL_PATH = [0, 0.8, 1.9, 1.2, 2.6, 3.4, 2.7, 3.0];
export const DELL_DAYS = [0, 7, 14, 21, 28, 35, 42, 47];
export const fmtPct = (v, d = 1) => `${v > 0 ? "+" : v < 0 ? "−" : ""}${Math.abs(v).toFixed(d)}%`;
